/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {
    FC,
    $NineSlicePlane,
    NineSlicePlaneProps,
} from '@gongxigames/framework/core/fragments/BuilderY';
import type {Size2D} from '@gongxigames/framework/core';
import {RESPONSIVE_CHANGE_EVENT} from '@gongxigames/framework/core/fragments/display/responsive';
import {Rectangle} from 'pixi.js';

export type PopupBgProps = Omit<NineSlicePlaneProps, 'slices'|'texture'>;

export const $PopupBg: FC<PopupBgProps> = (props) => {
    props.name ??= 'popup_bg';

    const hitArea = new Rectangle(0, 0, 0, 0);

    props.ref = (container) => {
        container.on(RESPONSIVE_CHANGE_EVENT, ({width, height}: Size2D) => {
            hitArea.width = width;
            hitArea.height = height;
        });
    };

    const propsPlane: NineSlicePlaneProps = {
        ...props,
        hitArea,
        texture: 'pp_background_sys_ui',
        slices: 64,
    };

    return $NineSlicePlane(propsPlane);
};